import React, { useEffect, useState } from 'react';
import SystemDashboard from 'layouts/SystemDashboard';
import {
  Button,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Box,
  Breadcrumbs,
  Link,
} from '@mui/material';
import { getAllUsers } from './UserService';

import { useNavigate } from 'react-router-dom';
// import { useTheme } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
// import IconButton from '@mui/material/IconButton';
// import DeleteIcon from '@mui/icons-material/Delete';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Container from 'components/Container';
import { notify } from 'utils/notify';
import { extractErrorMessage } from 'utils/extractErrorMessage';

const UserList = (): JSX.Element => {
  // const theme = useTheme();
  const [users, setUsers] = useState<any[]>([]);

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false); // State variable to track loading state
  const [openDialog, setOpenDialog] = useState(false);
  // const [userIdToDelete, setUserIdToDelete] = useState(null);

  useEffect(() => {
    listUsers();
  }, []);

  function listUsers(): void {
    setLoading(true);
    getAllUsers()
      .then((response) => {
        setUsers(response.data);
      })
      .catch((error) => {
        console.error(error);
        notify(extractErrorMessage(error));
      })
      .finally(() => {
        setLoading(false);
      });
  }

  // function addSection() {
  //   navigate('/system/dashboard/add-section');
  // }

  function selectUser(userid) {
    console.log(userid);
    navigate(`/system/dashboard/user/${userid}`);
  }

  // function updateUser(userid) {
  //   console.log(userid);
  //   navigate(`/update-user/${userid}`);
  // }

  // const handleDeleteConfirmation = (itemId) => {
  //   setUserIdToDelete(itemId);
  //   setOpenDialog(true);
  // };

  const handleDeleteItem = () => {
    notify('User delete function inactive');
    // Call your removeItem function to delete the item
    //removeUser(userIdToDelete);
    // Close the dialog
    setOpenDialog(false);
  };

  // function removeUser(userid) {
  //   deleteUser(userid)
  //     .then((response) => {
  //       // Item deleted successfully, update the list
  //       listUsers();
  //     })
  //     .catch((error) => {
  //       // Handle errors or exceptions
  //       if (error.response) {
  //         // The request was made and the server responded with a status code
  //         // Display an error message based on the response status
  //         console.error(
  //           'Request failed with status code:',
  //           error.response.status,
  //         );
  //         // Check if the error is due to a foreign key constraint violation
  //         if (
  //           error.response.status === 400 &&
  //           error.response.data.includes('foreign key constraint')
  //         ) {
  //           // Display a user-friendly error message informing the user that they can't delete the item
  //           notify(
  //             'Cannot delete the item because it is referenced by other records.',
  //           );
  //         }
  //         if (error.response.status === 401) {
  //           // Display a user-friendly error message informing the user that they can't delete the item
  //           notify(
  //             'Cannot delete or update a parent row: a foreign key constraint fails.',
  //           );
  //         } else {
  //           // Display a generic error message for other types of errors
  //           notify(
  //             'An error occurred while deleting the item. Please try again later.',
  //           );
  //         }
  //       } else if (error.request) {
  //         // The request was made but no response was received
  //         console.error(
  //           'Request made but no response received:',
  //           error.request,
  //         );
  //       } else {
  //         // Something happened in setting up the request that triggered an error
  //         console.error('Error setting up the request:', error.message);
  //       }
  //     });
  // }

  return (
    <Container>
      <SystemDashboard>
        <Box marginTop={2} marginBottom={4}>
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/">
              System Content
            </Link>
            <Typography color="text.primary">Users</Typography>
          </Breadcrumbs>
        </Box>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          marginBottom={4}
        >
          <Typography variant="h4">List of Users in System</Typography>
          {/* <Button variant="contained" onClick={addSection}>
            Add Section
          </Button> */}
        </Box>
        {loading && <p>Loading...</p>}
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 750 }} aria-label="simple table">
            <TableHead sx={{ bgcolor: 'alternate.main' }}>
              <TableRow>
                <TableCell>
                  <Typography
                    color={'text.secondary'}
                    variant={'caption'}
                    fontWeight={700}
                    sx={{ textTransform: 'uppercase' }}
                  >
                    ID
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography
                    color={'text.secondary'}
                    variant={'caption'}
                    fontWeight={700}
                    sx={{ textTransform: 'uppercase' }}
                  >
                    User Name
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography
                    color={'text.secondary'}
                    variant={'caption'}
                    fontWeight={700}
                    sx={{ textTransform: 'uppercase' }}
                  >
                    Last Name
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography
                    color={'text.secondary'}
                    variant={'caption'}
                    fontWeight={700}
                    sx={{ textTransform: 'uppercase' }}
                  >
                    Title
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography
                    color={'text.secondary'}
                    variant={'caption'}
                    fontWeight={700}
                    sx={{ textTransform: 'uppercase' }}
                  >
                    Email
                  </Typography>
                </TableCell>
                {/* <TableCell /> */}
                {/* <TableCell /> */}
              </TableRow>
            </TableHead>
            <TableBody>
              <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
                <DialogTitle>Confirm Deletion</DialogTitle>
                <DialogContent>
                  Are you sure you want to delete this section?
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
                  <Button onClick={handleDeleteItem} autoFocus>
                    Delete
                  </Button>
                </DialogActions>
              </Dialog>
              {users
                .sort((a, b) => a.id - b.id)
                .map((item, i) => (
                  <TableRow
                    key={i}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    onClick={() => selectUser(item.id)}
                  >
                    <TableCell component="th" scope="row">
                      <ListItem sx={{ p: 0, m: 0 }}>
                        <ListItemText primary={item.id} />
                      </ListItem>
                    </TableCell>
                    <TableCell>
                      <Typography>{item.firstName}</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography>{item.lastName}</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography>{item.email}</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        color={'primary'}
                        variant={'subtitle2'}
                        fontWeight={700}
                        sx={{ cursor: 'pointer' }}
                      >
                        Edit
                      </Typography>
                    </TableCell>
                    {/* <TableCell>
                    <Typography
                      color={'primary'}
                      variant={'subtitle2'}
                      fontWeight={700}
                      sx={{ cursor: 'pointer' }}
                    >
                      <IconButton
                        onClick={(event) => {
                          event.stopPropagation(); // Stop the click event from propagating
                          //handleDeleteConfirmation(item.id); // Show confirmation dialog before deleting
                        }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Typography>
                  </TableCell> */}
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </SystemDashboard>
    </Container>
  );
};

export default UserList;
